export const getInputValue = (value: unknown) => (typeof value === 'number' || typeof value === 'string' ? value : '')
